<template>
  <div class="Experience flex">
    <div class="flex-1 left-side">
      <sp-card class="cus-card" custom-class="sp-color-bg-4">
        <div v-show="tabelType === 'currently'">
          <el-table
              max-height="500"
              :data="dataList"
              style="width: 100%"
              :header-cell-style="{background:'#D6E9F0'}"
              row-key="id"
              class="el-table-out-border table-cell-20"
          >
            <el-table-column prop="date" min-width="80" :label="$l('Seri No.')">
              <template #default="scope">
                {{ scope.$index }}
              </template>
            </el-table-column>
            <el-table-column min-width="200" prop="date" :label="$l('Organization Name / Registry address')">
              <template #default="scope">
                <div class="">
                  <p class="item-p sp-color-11">{{ scope.row.department?.name }}</p>
                  <p v-if="scope.row.department?.nativeName" class="item-p sp-color-7">{{ scope.row.department?.nativeName }}</p>
                  <p class="item-p sp-color-7">
                    {{ scope.row.department?.city?.name }} <span v-if="scope.row.department?.city?.name">,
                  </span> {{ scope.row.department?.country?.name }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" min-width="200" :label="$l('Business Team Name / Office Location')">
              <template #default="scope">
                <p class="item-p sp-color-11 ">{{ scope.row.job.profession?.name }}</p>
              </template>
            </el-table-column>
            <el-table-column min-width="120" prop="date" :label="$l('Offered By')">
              <template #default="scope">
                <div class="">
                  <p class="item-p sp-color-11">{{ scope.row.department?.name }}</p>
                  <p v-if="scope.row.department?.nativeName" class="item-p sp-color-7">{{ scope.row.department?.nativeName }}</p>
                  <p class="item-p sp-color-7">
                    {{ scope.row.department?.city?.name }} <span v-if="scope.row.department?.city?.name">,
                  </span> {{ scope.row.department?.country?.name }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="120" prop="date" :label="$l('Terminated')">
              <template #default="scope">
                <div class="">
                  <p class="item-p sp-color-11">{{ scope.row.department?.name }}</p>
                  <p v-if="scope.row.department?.nativeName" class="item-p sp-color-7">{{ scope.row.department?.nativeName }}</p>
                  <p class="item-p sp-color-7">
                    {{ scope.row.department?.city?.name }} <span v-if="scope.row.department?.city?.name">,
                  </span> {{ scope.row.department?.country?.name }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="120" prop="date" :label="$l('Action')">
              <template #default="scope">
                <div class="">
                  <span title="dimission" class="iconfont icon-jiepin-01 pointer"
                  @click="toConfirm(scope.row)"></span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="tabelType === 'history'">
          <div style="font-width: 400;" class="mg-b-10">
            <SpButton :width="254" :height="36" type="warn" circle-radius="7" @click="toJobApply">
              + {{ $l('New Job Application') }}
            </SpButton>
          </div>
          <el-table
              max-height="500"
              :data="dataList"
              style="width: 100%"
              :header-cell-style="{background:'#D6E9F0'}"
              row-key="id"
              class="el-table-out-border table-cell-20"
          >
            <el-table-column prop="date" min-width="80" :label="$l('Seri No.')">
              <template #default="scope">
                {{ scope.$index }}
              </template>
            </el-table-column>
            <el-table-column min-width="150" prop="date" :label="$l('Organazation Name / Registry address')">
              <template #default="scope">
                <div class="">
                  <p class="item-p sp-color-11">{{ scope.row.department?.name }}</p>
                  <p v-if="scope.row.department?.nativeName" class="item-p sp-color-7">{{ scope.row.department?.nativeName }}</p>
                  <p class="item-p sp-color-7">
                    {{ scope.row.department?.city?.name }} <span v-if="scope.row.department?.city?.name">,
                  </span> {{ scope.row.department?.country?.name }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="date" min-width="120" :label="$l('Sent Time')">
              <template #default="scope">
                <p class="item-p sp-color-11 ">{{ scope.row.job.profession?.name }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </sp-card>
    </div>
    <div class="pd-l-20" style="width: 345px">
      <div class="sp-color-bg-4 pd-20" style="padding-top: 105px">
        <el-table
            :data="actionOps"
            style="width: 100%"
            :header-cell-style="{background:'#D6E9F0'}"
            row-key="id"
            class="el-table-out-border table-cell-20"
        >
          <el-table-column prop="date" min-width="180" :label="$l('Action')">
            <template #default="scope">
              <SpButton width="1" :height="36" :type="scope.row.value === tabelType ? 'warn1active' : 'warn1'"
                        circle-radius="7" @click="changeTableList(scope.row.value)">
                {{ scope.row.label }}
              </SpButton>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <SpDrawer v-model="showMoreModel" :width="0.94" :offset-top="20">
      <ExperienceMore :id="offerId" :info="{}" />
    </SpDrawer>
    <ConfirmDimission :show="confirmShow" :info="jobInfo" @close="confirmShow = false"></ConfirmDimission>
    <JobApplication :show="jobApplyShow" :info="jobInfo" @close="jobApplyShow = false"></JobApplication>
  </div>
</template>

<script type="text/ecmascript-6">
import { getIndividualExperienceJob, getOfferDetailAPI } from '@/request/APIs/natural'
import spCard from '@/components/common/SpCard'
import SpButton from '@/components/common/SpButton'
import spTable from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'
import SpIcon from '@/components/common/SpIcon'
import { getDateToFormatEn } from '@/utils/convert'
import { ref } from 'vue'
import ExperienceMore from '@/components/natural/personalProfile/ExperienceMore'
import SpDrawer from '@/components/common/SpDrawer'
import { nextTick } from '@vue/runtime-core'
import ConfirmDimission from '@/components/common/dialog/ConfirmDimission'
import JobApplication from '@/components/common/dialog/JobApplication'
export default {
  name: 'Experience',

  nameSpace: 'natural.personalProfile.Experience',
  components: {
    JobApplication,
    ConfirmDimission,
    SpDrawer,
    ExperienceMore,
    SpIcon,
    SpTableColumn,
    spCard,
    SpButton,
    spTable
  },

  props: {
  },

  setup () {
    const actionOps = [
      {
        label: 'Currently employed & Job carrier',
        value: 'currently'
      }, {
        label: 'Received Offer Letter',
        value: 'offer'
      }, {
        label: 'Job application history',
        value: 'history'
      }
    ]
    const tabelType = ref('currently')
    const changeTableList = (type) => {
      console.log(type)
      tabelType.value = type
    }
    const confirmShow = ref(false)
    const jobInfo = ref({})
    const toConfirm = (row) => {
      console.log(row)
      confirmShow.value = true
      jobInfo.value = row
    }

    const jobApplyShow = ref(false)
    const toJobApply = () => {
      jobApplyShow.value = true
    }

    // 旧
    const dataList = ref([])
    getIndividualExperienceJob().then(res => {
      dataList.value = res.data
    })

    const trigerRefs = ref([])
    const index = ref(0)
    const bindRef = (index, el) => {
      trigerRefs.value[index] = el
    }
    const showMoreModel = ref(false)
    const offerId = ref(null)
    const showMore = (row) => {
      showMoreModel.value = true
      offerId.value = row.id
    }
    return {
      actionOps,
      tabelType,
      changeTableList,
      toConfirm,
      confirmShow,
      jobInfo,
      toJobApply,
      jobApplyShow,

      dataList,
      showMore,
      getDateToFormatEn,
      showMoreModel,
      trigerRefs,
      offerId,
      index,
      bindRef
    }
  }
}
</script>

<style scoped lang="less">
.Experience{
  position:relative;
  width:100%;
  .item-p{
    margin: 0;
  }
  .left-side{
    .table{
      font-weight: bold;
      color: black;
      margin-top: @gap;
      .column{
        .content{
          color: #010101;
          line-height: 4px;
          .desc{
            font-weight: 400;
            opacity: 0.6;
          }
        }
      }
    }
  }
}
/deep/.cus-card {
  .card-content{
    >.slot {
      padding: 20px 2.5% 2.5% 2.5%;
    }
  }
}
</style>
